import type { Segment } from './types'

export const segments: Segment[] = [
  {
    id: 'S1',
    number: 1,
    name: 'Complete High Performers',
    nickname: 'The Stars',
    n: 59,
    percent: 20.9,
    color: '#F17922',
    colorName: 'orange',
    description: 'High on everything — the star consultants. Digitally comfortable, relationally skilled, socially aware, assertive closers. They perform without stress because their skills are internalized.',
    recommendation: 'Protect and reward. Assign most valuable leads. Mentor candidates for lower segments. Team leadership potential.',
    zScores: {
      F1: 0.61, F2: 0.42, F3: 0.88, F4: 0.45, F5: 0.07, F6: 0.76, F7: -0.15,
      F8: 0.30, F9: 0.73, F10: 0.78, F11: 0.78, F12: 0.55, F13: 0.04, F14: 0.59,
    },
  },
  {
    id: 'S2',
    number: 2,
    name: 'Confident Value Sellers',
    nickname: 'The Value Drivers',
    n: 52,
    percent: 18.4,
    color: '#2563EB',
    colorName: 'blue',
    description: 'Good skills, low price worry, not digital-averse. They sell through value, not pressure. Low stress and low complexity worry allows them to focus on client benefit.',
    recommendation: 'Ideal for complex, high-value products. Handle affluent or benefit-oriented leads. Train digital skills and relational depth.',
    zScores: {
      F1: 0.35, F2: -0.82, F3: 0.15, F4: 0.10, F5: -0.42, F6: -0.04, F7: -0.47,
      F8: 0.39, F9: -0.10, F10: 0.20, F11: 0.25, F12: -0.77, F13: 0.35, F14: 0.51,
    },
  },
  {
    id: 'S3',
    number: 3,
    name: 'Stressed Traditional Experts',
    nickname: 'The Pressured Veterans',
    n: 57,
    percent: 20.2,
    color: '#DC2626',
    colorName: 'red',
    description: 'Moderate expertise and communication, but high stress and critically very low mobilization. Anti-digital and low health domain knowledge. Burnout risk profile.',
    recommendation: 'Urgent attention. Reduce workload pressure, supportive digital upskilling, stable repeat-client portfolios. Monitor for burnout.',
    zScores: {
      F1: 0.44, F2: 0.25, F3: -0.42, F4: 0.15, F5: 0.60, F6: 0.27, F7: 0.20,
      F8: 0.10, F9: -0.62, F10: -0.05, F11: 0.01, F12: -0.30, F13: -0.96, F14: 0.38,
    },
  },
  {
    id: 'S4',
    number: 4,
    name: 'Disengaged Low-Identity',
    nickname: 'The Disconnected',
    n: 74,
    percent: 26.2,
    color: '#6B7280',
    colorName: 'gray',
    description: 'Very low scores on all identity factors. The defining characteristic is the collapse of professional self-concept. Not a skills gap but a motivation/confidence gap.',
    recommendation: 'Highest-priority development segment. Target professional identity building: mentorship, supervised wins, confidence workshops. Evaluate role fit if no improvement.',
    zScores: {
      F1: -1.38, F2: 0.15, F3: -0.20, F4: -1.23, F5: 0.30, F6: -0.36, F7: 0.10,
      F8: -0.66, F9: 0.05, F10: -0.10, F11: -0.32, F12: 0.10, F13: -0.05, F14: -1.44,
    },
  },
  {
    id: 'S5',
    number: 5,
    name: 'Reactive Non-Sellers',
    nickname: 'The Dormant Potential',
    n: 40,
    percent: 14.2,
    color: '#8B5CF6',
    colorName: 'purple',
    description: 'Very low active selling combined with very high mobilization and complexity awareness. Passive, trust-oriented consultants who react when pushed but don\'t proactively sell.',
    recommendation: 'Structured sales activation: assertive selling training, pair with S1 mentors. Shift from reactive to proactive. Solid low-stress foundation.',
    zScores: {
      F1: -0.20, F2: 0.05, F3: -0.30, F4: 0.23, F5: -0.62, F6: -1.14, F7: 0.54,
      F8: -0.65, F9: -0.15, F10: -0.76, F11: -1.30, F12: -0.10, F13: 0.90, F14: -0.25,
    },
  },
]

export const SEGMENT_COLORS = segments.map(s => s.color)
